import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../src/assets/icon/info.png'
import _imports_1 from '../../src/assets/icon/userinfo.png'
import _imports_2 from '../../src/assets/icon/i-01.png'
import _imports_3 from '../../src/assets/icon/zhinanzhen.png'
import _imports_4 from '../../src/assets/icon/phone.png'
import _imports_5 from '../../src/assets/image/ggh.png'
import _imports_6 from '@/assets/icon/login.png'
import _imports_7 from '@/assets/icon/search.png'
import _imports_8 from '@/assets/image/购物车.png'
import _imports_9 from '@/assets/icon/active.png'
import _imports_10 from '@/assets/icon/i-03.png'


const _withScopeId = n => (_pushScopeId("data-v-2ca0b3c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "box",
  id: "box"
}
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "container center" }
const _hoisted_4 = { class: "login" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p" }, "欢迎来到设纪元!", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/register" }, "免费注册", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "navigation" }
const _hoisted_12 = { class: "xiaoxi" }
const _hoisted_13 = {
  class: "el-dropdown-link",
  style: {"margin-top":"13px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "img"
}, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "number"
}
const _hoisted_16 = { class: "xiala" }
const _hoisted_17 = { class: "el-dropdown-link" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {"margin":"3px 80px"}
}, null, -1))
const _hoisted_20 = { class: "zhinan" }
const _hoisted_21 = { class: "el-dropdown-link" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {"margin":"3px 80px"}
}, null, -1))
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-dropdown-link" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 移动端访问 "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    style: {"margin":"3px 95px"}
  })
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  style: {"height":"247px","width":"100px"}
}, null, -1))
const _hoisted_32 = { class: "logo" }
const _hoisted_33 = { class: "container" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  class: "logimg"
}, null, -1))
const _hoisted_35 = { class: "search" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "search-llist" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "购物车", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/register",
  class: "newuser-a"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    alt: "",
    class: "newuser"
  })
], -1))
const _hoisted_43 = { class: "tabs" }
const _hoisted_44 = { class: "container" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "分类导航", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    alt: ""
  })
], -1))
const _hoisted_48 = { class: "list" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "list-1-box" }
const _hoisted_53 = { class: "list-1" }
const _hoisted_54 = { class: "list-1-item" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 0,
  class: "list-2"
}
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "customer" }
const _hoisted_60 = { class: "client" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "客户", -1))
const _hoisted_62 = { class: "text1" }
const _hoisted_63 = { class: "one" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "one" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "one" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "one" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "商户", -1))
const _hoisted_75 = { class: "text1" }
const _hoisted_76 = { class: "one" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "one" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_home_class = _resolveComponent("home-class")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_ctx.showName == '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "sonlogin"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("请登录")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.showName == '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.showName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: "/user",
                  class: "sonlogin"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.showName), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.showName)
            ? (_openBlock(), _createElementBlock("p", {
                key: 3,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loginOut && _ctx.loginOut(...args)))
              }, "退出登录"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, { to: { name: 'mymessage' } }, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_13, [
                      _hoisted_14,
                      _createTextVNode(" 我的消息 "),
                      (_ctx.messageNumber > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_dropdown, null, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'aside' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本信息")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'myorder' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("我的订单 ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'project' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("我的收藏 ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'myfootmark' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("我的足迹")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'customer' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("客户服务")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'mylocation' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("我的地址")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'myaccount' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("我的账户")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'myvip' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("我的会员")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'discountcoupon' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("我的优惠券")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'works' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("我的上传")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'mymessage' },
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("我的消息")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, { onClick: _ctx.loginOut }, {
                      default: _withCtx(() => [
                        _createTextVNode("退出账号 ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_router_link, {
                    to: "/user",
                    style: {"text-decoration":"none"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18,
                      _createTextVNode(" 个人中心 "),
                      _hoisted_19
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_el_dropdown, null, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, { slot: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
												name: 'guidance',
												params: {
													comName: 'LoginIntroduceVue',
												},
											},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("span", {
                              onClick: navigate,
                              role: "link"
                            }, "功能介绍", 8, _hoisted_24)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
												name: 'guidance',
												params: {
													comName: 'Function',
												},
											},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("span", {
                              onClick: navigate,
                              role: "link"
                            }, "登录设纪元", 8, _hoisted_25)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
												name: 'guidance',
												params: {
													comName: 'Shopping',
												},
											},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("span", {
                              onClick: navigate,
                              role: "link"
                            }, "购物流程", 8, _hoisted_26)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
												name: 'guidance',
												params: {
													comName: 'Download',
												},
											},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("span", {
                              onClick: navigate,
                              role: "link"
                            }, "设计方案下载", 8, _hoisted_27)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
												name: 'guidance',
												params: {
													comName: 'Consult',
												},
											},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("span", {
                              onClick: navigate,
                              role: "link"
                            }, "咨询服务", 8, _hoisted_28)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
												name: 'guidance',
												params: {
													comName: 'WorkUpload',
												},
											},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("span", {
                              onClick: navigate,
                              role: "link"
                            }, "作品上传及发布", 8, _hoisted_29)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_21, [
                  _createVNode(_component_router_link, { to: { name: 'guidance' } }, {
                    default: _withCtx(() => [
                      _hoisted_22,
                      _createTextVNode(" 新手指南 "),
                      _hoisted_23
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_dropdown, null, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _hoisted_30
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_34
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_35, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sv) = $event)),
              placeholder: "机械手",
              class: "placeholderStyle",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.toSearch()), ["enter","native"]))
            }, null, 544), [
              [
                _vModelText,
                _ctx.sv,
                void 0,
                { trim: true }
              ]
            ]),
            _createElementVNode("div", {
              class: "magnifier",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toSearch()))
            }, _hoisted_37)
          ]),
          _createElementVNode("ul", _hoisted_38, [
            _createElementVNode("li", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toSearch('机械手')))
            }, "机械手"),
            _createElementVNode("li", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toSearch('工作站')))
            }, "工作站"),
            _createElementVNode("li", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toSearch('末端执行器')))
            }, "末端执行器"),
            _createElementVNode("li", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toSearch('输送线')))
            }, "输送线"),
            _createElementVNode("li", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toSearch('视觉方案')))
            }, "视觉方案")
          ])
        ]),
        _createElementVNode("div", {
          class: "shoppingcar",
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.gotoCart && _ctx.gotoCart(...args)))
        }, [
          _hoisted_39,
          _createElementVNode("div", null, _toDisplayString(_ctx.cartTotal ? _ctx.cartTotal : 0), 1),
          (_ctx.cartTotal == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, "0"))
            : _createCommentVNode("", true),
          _hoisted_41
        ]),
        _hoisted_42
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", {
          class: "classification",
          onMouseleave: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onMouseleave && _ctx.onMouseleave(...args))),
          onMouseenter: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onMouseenter && _ctx.onMouseenter(...args)))
        }, [
          _hoisted_45,
          _hoisted_46,
          _hoisted_47,
          (_ctx.showClass != 'home')
            ? (_openBlock(), _createBlock(_component_home_class, {
                key: 0,
                class: "home-class"
              }))
            : _createCommentVNode("", true)
        ], 32),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("ul", null, [
            _createVNode(_component_router_link, {
              to: { name: 'works' },
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("li", {
                  onClick: navigate,
                  class: _normalizeClass({ active: _ctx.showClass == 'works' }),
                  role: "link"
                }, " 上传作品 ", 10, _hoisted_49)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'activity' },
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("li", {
                  onClick: navigate,
                  class: _normalizeClass({ active: _ctx.showClass == 'activity' }),
                  role: "link"
                }, " 折扣专区 ", 10, _hoisted_50)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'spareHome' },
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("li", {
                  role: "link",
                  class: "parts-li",
                  onClick: navigate
                }, [
                  _createTextVNode(" 备件区 "),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partsClass.data, (mclass, index) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createVNode(_component_router_link, {
                            to: {
													name: 'partssearch',
													params: { pid: mclass.id, sid: 0 },
												},
                            custom: ""
                          }, {
                            default: _withCtx(({ navigate }) => [
                              _createElementVNode("li", {
                                class: "list-1-item-list",
                                onClick: navigate,
                                role: "link"
                              }, _toDisplayString(mclass.names), 9, _hoisted_55)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          (mclass.son.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mclass.son, (item, iindex) => {
                                  return (_openBlock(), _createBlock(_component_router_link, {
                                    to: {
															name: 'partssearch',
															params: { pid: mclass.id, sid: item.id },
														},
                                    custom: ""
                                  }, {
                                    default: _withCtx(({ navigate }) => [
                                      _createElementVNode("li", {
                                        onClick: navigate,
                                        role: "link"
                                      }, _toDisplayString(item.names), 9, _hoisted_57)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                }), 256))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256))
                    ])
                  ])
                ], 8, _hoisted_51)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'firmCooperation' },
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("li", {
                  onClick: navigate,
                  role: "link",
                  class: _normalizeClass({ active: _ctx.showClass == 'firmCooperation' })
                }, " 生态合作伙伴 ", 10, _hoisted_58)
              ]),
              _: 1
            }),
            _createElementVNode("li", _hoisted_59, [
              _createVNode(_component_el_dropdown, null, {
                dropdown: _withCtx(() => [
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_router_link, {
                          to: {
														name: 'customer',
														params: {
															comName: 'HotProblem',
														},
													},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("p", {
                              onClick: navigate,
                              role: "link"
                            }, "热点问题", 8, _hoisted_64)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          to: {
														name: 'customer',
														params: {
															comName: 'GeRenVip',
														},
													},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("p", {
                              onClick: navigate,
                              role: "link"
                            }, "会员制度", 8, _hoisted_65)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_router_link, {
                          to: {
														name: 'customer',
														params: {
															comName: 'Chilunbi',
														},
													},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("p", {
                              onClick: navigate,
                              role: "link"
                            }, "账户管理", 8, _hoisted_67)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          to: {
														name: 'customer',
														params: {
															comName: 'ZaixianZhifu',
														},
													},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("p", {
                              onClick: navigate,
                              role: "link"
                            }, "支付方式", 8, _hoisted_68)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_router_link, {
                          to: {
														name: 'customer',
														params: {
															comName: 'Fapiao',
														},
													},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("p", {
                              onClick: navigate,
                              role: "link"
                            }, "售后服务", 8, _hoisted_70)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          to: {
														name: 'customer',
														params: {
															comName: 'GerenRenzheng',
														},
													},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("p", {
                              onClick: navigate,
                              role: "link"
                            }, "实名认证", 8, _hoisted_71)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createVNode(_component_router_link, {
                          to: {
														name: 'customer',
														params: {
															comName: 'ShejishiHezuo',
														},
													},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("p", {
                              onClick: navigate,
                              role: "link"
                            }, "设计师合作", 8, _hoisted_73)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _hoisted_74,
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createVNode(_component_router_link, {
                          to: {
														name: 'customer',
														params: {
															comName: 'QiyeHezuo',
														},
													},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("p", {
                              onClick: navigate,
                              role: "link"
                            }, "企业合作", 8, _hoisted_77)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          to: {
														name: 'customer',
														params: {
															comName: 'QiyeRenzheng',
														},
													},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("p", {
                              onClick: navigate,
                              role: "link"
                            }, "企业认证", 8, _hoisted_78)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createVNode(_component_router_link, {
                          to: {
														name: 'customer',
														params: {
															comName: 'ZuopinShangchuan',
														},
													},
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("p", {
                              onClick: navigate,
                              role: "link"
                            }, "作品上传", 8, _hoisted_80)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: { name: 'customer' },
                    style: {"text-decoration":"none"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["el-dropdown-link", { active: _ctx.showClass == 'customer' }])
                      }, [
                        _createTextVNode(" 客户服务 "),
                        _createVNode(_component_el_icon, { class: "el-icon--right" })
                      ], 2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_router_link, {
              to: { name: 'aboutour' },
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("li", {
                  onClick: navigate,
                  role: "link",
                  class: _normalizeClass({ active: _ctx.showClass == 'aboutour' })
                }, " 关于我们 ", 10, _hoisted_81)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'myvip' },
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("li", {
                  onClick: navigate,
                  class: _normalizeClass({ active: _ctx.showClass == 'activity' }),
                  role: "link",
                  style: {"width":"130px"}
                }, " 个人/企业会员 ", 10, _hoisted_82)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}